import styles from "./SectionHistory.module.css";
import aboutImage30 from "../../assets/images/somos/Group 36.png";
import notaImage from "../../assets/images/somos/NOTA 30 AÑOS EL INDUSTRIAL OK 1.png";

const SectionHistory = () => {
  return (
    <div className={styles.sectionContainer}>
      <div className={styles.title}>Nuestra historia</div>

      <img
        src={aboutImage30}
        alt="Imagen introductoria"
        className={styles.introImage}
        loading="lazy"
      />

      <div className={styles.subheading}>
        TRANSFORMANDO LA COMUNCACIÓN EN LA INDUSTRIA
      </div>

      <div className={styles.contentWrapper}>
        {/* Primera columna */}
        <div className={styles.textBlock}>
          <span className={styles.italicTitle}>
            Compromiso con la excelencia informativa.
          </span>
          <p>
            Hace treinta años, en un contexto donde la información sobre
            transporte era limitada, surgió en Nuevo León un proyecto que
            cambiaría la forma de comunicar en el sector industrial: <br />
            La revista “El Industrial de Monterrey”. Fundada originalmente bajo
            el nombre de Guía Express, este medio fue el principio en abordar de
            manera especializada temas de transporte en la región, y con el
            tiempo se convirtió en una referencia clave para los profesionales
            del sector.
            <br />
            <br />
            Permanecer es todo un reto para cualquier emprendimiento, pero
            cuando hablamos de medios de comunicación en verdad es una hazaña.
            Hemos sabido adaptarnos a las necesidades de información para
            mantenernos siempre con el compromiso de transmitir los sucesos más
            relevantes en la industria.
            <br />
            <br />
            Lo que comenzó como una publicación modesta, enfocada en
            proporcionar información confiable sobre transporte, rápidamente se
            consolidó como una herramienta esencial para el conocimiento
            especializado, en un escenario donde pocos medios exploraban este
            nicho.
          </p>

          <span className={styles.italicTitle}>
            Visionarios que marcaron el camino.
          </span>
          <p>
            Detrás del nacimiento de ese proyecto se encuentran Martha Alicia
            Torres Sepúlveda y Juventino Rodríguez Espinosa, los visionarios que
            apostaron por crear un medio que informara y educara sobre un sector
            en constante transformación. Desde su creación, Martha Alicia Torres
            ha sido una figura central en la evolución de El Industrial,
            liderando con pasión y dedicación, un proyecto que ha cruzado
            fronteras y ampliado su alcance hacia otros sectores, como el acero
            y la energía.
            <br />
            <br />
            Su liderazgo ha sido clave no solo para la continuidad del medio,
            sino también para posicionarlo como un referente indispensable en la
            industria. Desde eventos sectoriales hasta entrevistas profundas con
            líderes del transporte. Torres Sepúlveda ha construido un legado de
            excelencia periodística y visión estratégica, que sigue guiando a la
            revista hacía el futuro.
          </p>
        </div>

        {/* Segunda columna */}
        <div className={styles.imageBlock}>
          <span className={styles.italicTitle}>
            Evolución y expansión hacía nuevas áreas.
          </span>
          <p>
            Con el paso del tiempo, Guía Express amplió sus horizontes,
            integrando temas relacionados con la industria del acero, la energía
            y otros sectores estratégicos. Esta expansión dio lugar a una nueva
            identidad: El Industrial de Monterrey, un nombre que refleja su
            compromiso con la modernización y la diversificación de los
            contenidos que ofrece a sus lectores.
            <br />
            <br />
            Durante estas tres décadas, la revista El Industrial de Monterrey ha
            estado presente en los eventos y exposiciones más importantes de la
            industria en México, consolidando su posición como una fuente
            confiable de información actualizada para empresas y profesionales.
            <br />
            <br />A lo largo de los años, El Industrial de Monterrey ha contado
            con el apoyo continuo de clientes y anunciantes, quienes han sido un
            motor vital para su permanencia en el mercado. Gracias a esta
            confianza, la revista ha mantenido su enfoque en ofrecer contenido
            objetivo y de calidad, ayudando a las empresas a conectarse con un
            público ávido de conocimiento especializado.
            <br />
            <br />
            En un entorno donde la información es poder, El Industrial de
            Monterrey sigue siendo la primera revista de transporte en Nuevo
            León, abriendo el camino para otros medios especializados en la
            región.
          </p>

          <img src={notaImage} alt="Historia imagen" loading="lazy" />
        </div>
      </div>
    </div>
  );
};

export default SectionHistory;
